import { ConfigProvider, TableProps } from "antd";
import AntTable from "antd/es/table";
import type { ColumnsType } from "antd/es/table";
import { Empty } from "antd";

type Prop<T extends object> = {
  columns: ColumnsType<T>;
  dataSource: T[];
  pagination?: false | TableProps["pagination"];
  rowKey: string;
  rowSelectionType?: "checkbox" | "radio";
  onRowSelect?: (selectedRowKeys: React.Key[], selectedRows: T[]) => void;
  size?: "small" | "middle" | "large";
  bordered?: boolean;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  loading?: boolean;
  rowHoverable?: boolean;
  showHeader?: boolean;
  className?: string;
  rowClassName?: string | ((record: T, index: number) => string);
  scroll?: {
    scrollToFirstRowOnChange?: boolean;
    x?: true | number | string;
    y?: number | string; //If needed to set the table height  to the remaining screen hight a scc based approach such as calc(100vh - 28em) can be used
  };
  nullText?: string;
  onRow?: any;
  borderColor?: string;
};

export const Table = <T extends object>(props: Prop<T>) => {
  const {
    scroll = { x: true },
    borderColor = "#fff",
    nullText = " - ",
    ...otherProps
  } = props;

  const enhancedColumns = otherProps.columns.map((col) => {
    if (!col.render) {
      return {
        ...col,
        render: (text: any) =>
          text === null || text === undefined || text === "" ? (
            <span className=" text-red-700 ">{nullText}</span>
          ) : (
            text
          ),
      };
    } else {
      return col;
    }
  });

  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            headerBg: "#F0F6FF",
            headerColor: "#667085",
            cellPaddingBlock: 10,
            colorInfoText: "#667085",
            borderColor: "#ebecef",
          },
          Pagination: {
            colorPrimary: "#FFF",
            colorText: "#667085",
          },
        },
      }}
    >
      <div className="table-container  rounded-[4px]">
        <AntTable<T>
          columns={enhancedColumns}
          className="custom-table"
          rowClassName={props?.rowClassName}
          dataSource={otherProps?.dataSource}
          scroll={scroll}
          rowKey={otherProps.rowKey}
          size={otherProps.size}
          pagination={otherProps.pagination}
          bordered={otherProps.bordered}
          loading={otherProps.loading}
          rowHoverable={otherProps.rowHoverable}
          onRow={props.onRow}
          showHeader={otherProps.showHeader}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_DEFAULT}
                description={
                  <span>Select a stock to uncover its financial story</span>
                }
              />
            ),
          }}
          {...(otherProps.rowSelectionType && {
            rowSelection: {
              type: otherProps.rowSelectionType,
              onChange: otherProps.onRowSelect,
            },
          })}
          {...(otherProps.footer && {
            footer: () => otherProps.footer,
          })}
          {...(otherProps.header && {
            title: () => otherProps.header,
          })}
        />
      </div>
    </ConfigProvider>
  );
};
